import { EventCollectionDTO } from './EventCollectionDTO'
import { EventCollectionRaw } from './EventCollectionRaw'
import { EventDTOFactory } from './EventDTOFactory'

export class EventCollectionDTOFactory {
  static fromRaw(raw: EventCollectionRaw): EventCollectionDTO {
    return new EventCollectionDTO(raw.result.map(EventDTOFactory.fromRaw), raw.total_items)
  }
}
